import { atom } from "jotai";

export const isAcceptingSuggestionStateAtom = atom(false);
isAcceptingSuggestionStateAtom.debugLabel = "isAcceptingSuggestionStateAtom";
